import React from "react";

const getComponent = (label, pagesContext) => {
  const fileName = label + ".js";
  const pageComponent = pagesContext.keys().find((key) => key.includes(fileName));
  if (pageComponent) {
    return React.lazy(() => import(`../pages/${pageComponent.replace('./', '')}`));
  }
  return React.lazy(() => import(`../pages/NotFound.js`));
};

export default getComponent;
